import Config from '../_core/config';

export function authHeader(options = null) {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));

    if(options){
        let headers = { 
            'Authorization': 'Bearer ' + user.token, 
            'Content-type': 'application/json',
            'x-client-id': Config.api.client,
            'x-client-secret': Config.api.secret
        }
        
        Object.assign(headers, options);

        return headers;
    }
    
    if (user && user.token) {
        return { 
        	'Authorization': 'Bearer ' + user.token, 
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-client-id': Config.api.client,
            'x-client-secret': Config.api.secret
        };
    } else {
        return { 
            'Content-type': 'application/json',
            'x-client-id': Config.api.client,
            'x-client-secret': Config.api.secret
        };
    }
}